import React, { Dispatch, SetStateAction } from "react";
import Newcommontable from "../Tables/NewCommonTable";
import DeviceMeterTable from "../Tables/Device/DeviceMeterTable";

function DeviceMeterTablePage({
  Data,
  pageSize,
  pageind,
  GetList,
  setpageSize,
  setPageInd,
  setShowresetvalueModal,
  setShowreplacemeterModal,
  setShowModal,
  setShowConfirmModal,
  setsubscribe,
}: {
  Data: any;
  pageSize: number;
  pageind: number;
  setpageSize: Dispatch<SetStateAction<number>>;
  setPageInd: Dispatch<SetStateAction<number>>;
  GetList: () => any;
  setShowresetvalueModal: any;
  setShowreplacemeterModal: any;
  setShowModal: any;
  setShowConfirmModal: any;
  setsubscribe: any;
}) {
  return (
    <>
      <Newcommontable
        Children={
          <DeviceMeterTable
            Data={Data}
            pageSize={pageSize}
            pageind={pageind}
            GetList={GetList}
            setpageSize={setpageSize}
            setPageInd={setPageInd}
            OBJHead={[
              "S.No",
              "Meter Name",
              "Slave ID",
              // "Register Type",
              "Make",
              "Model",
              "Data Bits",
              "Stop Bits",
              "Parity",
              "Parameter Type",
              "Parameter List",
              "Total Units",
              "Subscription Status",
              "Subscription Start Date ",
              "Subscription End Date",
              "History",
              "Action",
            ]}
            OBJKeys={[
              "meter_name",
              "meter_code",
              // "register_type",
              "make_name",
              "model_name",
              "databits",
              "stopbits",
              "parity_name",
              "parameter_type",
              "parameter_list",
              "wh_received",
              "subscription_status_name",
              "subscription_start",
              "subscription_end",
              "history",
            ]}
            setShowresetvalueModal={setShowresetvalueModal}
            setShowreplacemeterModal={setShowreplacemeterModal}
            setShowModal={setShowModal}
            setShowConfirmModal={setShowConfirmModal}
            setsubscribe={setsubscribe}
          />
        }
        style={{
          overflow: "auto",
          maxHeight: "320px",
          margin: "5px 0 47px 0",
        }}
      />
    </>
  );
}

export default DeviceMeterTablePage;
